module.exports = __webpack_public_path__ + "assets/img/hotZone.5102bdb1.svg";